import React from "react";
import { useSelector } from "react-redux";
import SnackbarContent from "./SnackbarContent";

import "./style.css";

const SnackBar = () => {
  const snacks = useSelector(state => state.ui.snackbars.items);
  const bottomSnacks = snacks.filter(item => item.placement !== "top-right");
  const topRightSnacks = snacks.filter(item => item.placement === "top-right");

  const renderSnack = item => (
    <SnackbarContent
      key={item.id}
      id={item.id}
      status={item.status}
      message={item.message}
      actionButton={item.actionButton}
      autoHide={item.autoHide}
    />
  );

  return (
    <>
      <div className="snackbars">{bottomSnacks.map(renderSnack)}</div>
      <div className="snackbars snackbars--top-right">
        {topRightSnacks.map(renderSnack)}
      </div>
    </>
  );
};

export default SnackBar;
